/**
 * Util to generate URL params based filters.
 */
const IdsFilterGenerator = {
  /**
   * Creates the filter URL params for the given filter state / data.
   *
   * @param {String} locationTypeSelection
   * @param {Object} corpusSelection
   * @param {Object} [geographicSelection=Null]
   * @returns {String} The filter as URL params
   */
  createFilter (locationTypeSelection, corpusSelection, geographicSelection) {
    const locTypeFilter = IdsFilterGenerator.createLocationTypeFilter(locationTypeSelection);

    let filter;
    if (geographicSelection && geographicSelection.countrySelection) {
      const geogFilter = IdsFilterGenerator.createGeographicFilter(geographicSelection);

      filter = `${locTypeFilter}&${geogFilter}`;
    } else if (corpusSelection) {
      const corpusFilter = IdsFilterGenerator.createCorpusFilter(corpusSelection);

      filter = `${corpusFilter}&${locTypeFilter}`;
    }

    return filter;
  },

  /**
   * Creates the filter URL param for the given location type selection.
   *
   * @param {String} locationTypeSelection Single location type selection
   * @returns {String} The filter as URL param 'v_ortstyp=Aufnahmeort'
   */
  createLocationTypeFilter (locationTypeSelection) {
    return 'v_ortstyp=' + locationTypeSelection;
  },

  /**
   * Creates the filter URL param for the given location type selection array.
   *
   * NOT IN USE AT THE MOMENT
   *
   * @param {Array} locationTypeSelection location type selection
   * @returns {String} The filter as URL param 'v_ortstyp=foo|bar'
   */
  createLocationTypeFilterMulti (locationTypeSelection) {
    // remove null items
    const selectionWoNulls = locationTypeSelection.filter(
      item => item !== null
    );
    const filterVal = selectionWoNulls.join('|');
    return 'v_ortstyp=' + filterVal;
  },

  /**
   * Creates the filter URL param for the given corpus selection selection.
   *
   * @param {Array} corpusSelection location type selection
   * @returns {String} The filter as URL param 'v_location_type=...'
   */
  createCorpusFilter (corpusSelection) {
    // iterate all selections based on corpus category
    let mergedSelection = [];
    for (const category in corpusSelection) {
      // merges and removes duplicates
      mergedSelection = mergedSelection.concat(
        corpusSelection[category].filter(
          item => { return item !== null && mergedSelection.indexOf(item) < 0 }
        )
      );
    }

    // v_corpus_id=IS--|ISW-|ISZ-
    return `v_corpus_id=${mergedSelection.join('|')}`;
  },

  /**
   * Creates the filter URL param for the given geographic selection.
   *
   * @param {Object} geographicSelection geographic selection object aggregating
   *   the filters with the keys 'countrySelection', regionSelection', 'districtSelection'
   * @returns {String} The filter as URL param string
   */
  createGeographicFilter (geographicSelection) {
    let filter = '';
    for (const key in geographicSelection) {
      const geogSel = geographicSelection[key];
      if (!geogSel) {
        continue;
      }
      if (key === 'countrySelection') {
        filter += `v_iso=${geogSel.iso}`;
      } else if (key === 'regionSelection') {
        filter += `&v_region=${geogSel.name}`;
      } else if (key === 'districtSelection') {
        filter += `&v_landkreis=${geogSel.name}`;
      }
    }

    return filter;
  }

}

export default IdsFilterGenerator;



// WEBPACK FOOTER //
// ./app/ids/IdsFilterGenerator.js